import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { UploadLater, UploadNow } from '../../../assets'

const ThankYouComp = () => {

    const dataInputRegistration = useSelector(state => state.dataInputRegistration)

    const redirectToRiwayatTransaksi = () => {
        window.location.href = '/riwayat-transaksi'
    }

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    return (
        <div>
            {
                dataInputRegistration.checkoutNow === true ?
                    <>
                        <div className='row'>
                            <h1
                                className='text-center mt-4'
                                style={{ fontSize: size.width < 500 ? '15px' : '24px', fontWeight: '700', color: '#26D07C' }}
                            >
                                Pendaftaran Selesai!
                            </h1>
                            <h4
                                className='text-center mt-3'
                                style={{ fontSize: size.width < 500 ? '13px' : '16px', fontWeight: '600' }}
                            >
                                Terima kasih telah mendaftar!
                            </h4>
                            <p
                                className='text-center mt-3'
                                style={{ fontSize: size.width < 500 ? '13px' : '16px' }}
                            >
                                Admin kami segera memproses pendaftaran program Anda, <br />
                                Silahkan cek riwayat transaksi melalui dashboard website!
                            </p>

                            <div className='col-12 text-center mt-3'>
                                {
                                    size.width < 500 ?
                                        <button className='btn btn-sm btn-primary' onClick={redirectToRiwayatTransaksi}>Go to Dashboard</button>
                                        :
                                        <button className='btn btn-lg btn-primary' onClick={redirectToRiwayatTransaksi}>Go to Dashboard</button>
                                }
                            </div>

                            <div className='col-12 text-center mt-3 mb-3'>
                                <img src={UploadNow} alt='upload-later' width={size.width < 500 ? '100%' : '50%'} />
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className='row'>
                            <h1
                                className='text-center mt-4'
                                style={{ fontSize: size.width < 500 ? '15px' : '24px', fontWeight: '700', color: '#F1416C' }}
                            >
                                Terima kasih telah mendaftar di program prasmul-eli.
                            </h1>
                            <p
                                className='text-center mt-3'
                                style={{ fontSize: size.width < 500 ? '13px' : '16px' }}
                            >
                                Yuk selesaikan proses pendaftaran dengan melengkapi data dan menyelesaikan pembayarannya!

                                {/* Silahkan lengkapi <b>Data Konfirmasi Pembayaran</b> anda melalui Dashboard kami, <br />
                                supaya Admin kami segera memproses pendaftaran program Anda! */}
                            </p>

                            <div className='col-12 text-center mt-3'>
                                {
                                    size.width < 500 ?
                                        <button className='btn btn-sm btn-primary' onClick={redirectToRiwayatTransaksi}>Go to Dashboard</button>
                                        :
                                        <button className='btn btn-lg btn-primary' onClick={redirectToRiwayatTransaksi}>Go to Dashboard</button>
                                }
                            </div>

                            <div className='col-12 text-center mt-3 mb-3'>
                                <img src={UploadLater} alt='upload-later' width={size.width < 500 ? '100%' : '50%'} />
                            </div>
                        </div>
                    </>
            }
        </div>
    )
}

export default ThankYouComp
